import React, { useState, useEffect, useRef } from "react";
import "../../../pages/styles.css";
import { useNavigate } from "react-router-dom";
import { routePath as RP } from "../../../app/components/router/routepath";
import { useDispatch } from "react-redux";
import { updateSponsor } from "../../../app/redux/slices/SponsorSlice";
import Swal from "sweetalert2";
import { uploadFormFilesReq } from "../../../api/scholarshipapplication/scholarshipapplication";

import { ApiKey } from "../../../api/endpoint";
import { publicAxios } from "../../../api/config";
import { fetchSponsorById } from "../../../app/redux/slices/SponsorSlice";
export default function SponsorProfileForm({ profile, onCancel, onSave }) {
  const [formData, setFormData] = useState(profile || {});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  // -------------------------------
  // REGEX RULES
  // -------------------------------
  const orgNameRegex = /^[A-Za-z ]+$/;
  const nameRegex = /^[A-Za-z ]+$/;
  //const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.(com|org|edu)$/;
  const emailRegex = /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z]{2,}$/;

  const phoneRegex = /^[0-9]{10}$/;
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/\S*)?$/;
  const numberRegex = /^[0-9]+$/;

  // -------------------------------
  // AUTO-BLOCK HANDLERS
  // -------------------------------

  // Letters + spaces only
  const handleLetterInput = (key, value) => {
    const clean = value.replace(/[^A-Za-z ]/g, "");
    setFormData({ ...formData, [key]: clean });
  };

  // Digits only
  const handleNumberInput = (key, value) => {
    const clean = value.replace(/[^0-9]/g, "");
    setFormData({ ...formData, [key]: clean });
  };

  // Website (no spaces)
  const handleWebsiteInput = (value) => {
    const clean = value.replace(/\s/g, "");
    setFormData({ ...formData, website: clean });
  };

  // Email (lowercase + block spaces)
  const handleEmailInput = (value) => {
  setFormData({ ...formData, email: value.toLowerCase() });
};

  // Address (remove triple spaces)
  const handleAddressInput = (value) => {
    const clean = value.replace(/\s{2,}/g, " ");
    setFormData({ ...formData, address: clean });
  };

  const isValidEmail = (email) => {
  email = email.trim();
 
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!regex.test(email)) return false;
 
  const [local, domain] = email.split("@");
  if (!local || !domain) return false;
 
  if (local.startsWith(".") || local.endsWith(".")) return false;
  if (local.includes("..")) return false;
 
  if (domain.startsWith(".") || domain.endsWith(".")) return false;
  if (domain.includes("..")) return false;
 
  const domainParts = domain.split(".");
  if (domainParts.length < 2) return false;
 
  const lastIndex = domainParts.length - 1;
  if (domainParts[lastIndex] === domainParts[lastIndex - 1]) return false;
 
  for (let part of domainParts) {
    if (!/^[a-zA-Z0-9-]+$/.test(part)) return false;
    if (part.startsWith("-") || part.endsWith("-")) return false;
  }
 
  return true;
};
  // -------------------------------
  // VALIDATION
  // -------------------------------
  const validateForm = () => {
    const errs = {};

    if (!formData.sponsorName || !orgNameRegex.test(formData.sponsorName)) {
      errs.sponsorName = "Only letters (A–Z) and spaces allowed.";
    }

    if (!formData.sponsorType) {
      errs.sponsorType = "Organization type is required.";
    }

    // if (formData.website && !urlRegex.test(formData.website)) {
    //   errs.website = "Enter a valid website URL.";
    // }

    // if (formData.contactPerson && !nameRegex.test(formData.contactPerson)) {
    //   errs.contactPerson = "Only letters and spaces allowed.";
    // }

  if (
  !formData.email || 
  !isValidEmail(formData.email) || 
  formData.email.includes("..")
) {
  errs.email = "Enter a valid email address.";
}

    if (!formData.phone || !phoneRegex.test(formData.phone)) {
      errs.phone = "Phone number must be exactly 10 digits.";
    }

    if (!formData.address || formData.address.length < 5) {
      errs.address = "Address must be at least 5 characters.";
    }

    // if (!formData.budget || !numberRegex.test(formData.budget)) {
    //   errs.budget = "Budget must be a valid number.";
    // }

    // if (!formData.studyLevels) {
    //   errs.studyLevels = "Please select a study level.";
    // }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const [selectedFiles, setSelectedFiles] = useState([]); // newly selected files
  const [filesList, setFilesList] = useState(profile?.files || []);
  console.log(filesList, "filelist"); // display names
  const [fileSelected, setFileSelected] = useState(false);
  //const [newFileSelected, setNewFileSelected] = useState(false);
  const [newFileSelected, setNewFileSelected] = useState(false);
  const [existingDocFiles, setExistingDocFiles] = useState([]);
  const [originalFiles, setOriginalFiles] = useState([]);
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files || files.length === 0) return;

    // No file type restriction
    setSelectedFiles(files);
    setFilesList(files.map(f => f.name));
    setFileSelected(true);
    setNewFileSelected(true);
    setFormData({ ...formData, documents: files });
  };
  // Upload files function returns uploaded file names
  const uploadFiles = async (applicationId) => {
    if (selectedFiles.length < 1) return [];

    const formDataPayload = new FormData();
    selectedFiles.forEach((file) => formDataPayload.append("FormFiles", file));
    formDataPayload.append("TypeofUser", "sponsor");
    formDataPayload.append("id", applicationId);

    try {
      await uploadFormFilesReq(formDataPayload);

      // Return names of uploaded files for merging
      return selectedFiles.map(f => f.name);
    } catch (ex) {
      console.error("File upload failed:", ex);
      return [];
    }
  };
  const downloadFileFun = async (id, type) => {
    try {
      
      //const res = await AsyncGetFiles(API.downloadScholarshipFiles + "?id=" + id);
      //const res= await 
      const res = await publicAxios.get(
        `${ApiKey.downloadscholarshipFiles}/${id}/${type}`,
        { responseType: "blob" }   // <-- important for file download
      );


      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/zip" })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "documents.zip"); // you can rename as needed
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (err) {
      console.error("File download failed:", err);
    }
  };
  useEffect(() => {
    if (profile) {
      setFilesList(profile.files || []);
      setExistingDocFiles(profile.files || []);
      setOriginalFiles(profile.files || []);

      setFormData(prev => ({
        ...prev,
        fileName: profile.files?.join("|") || "",
        filePath: profile.filePath || ""

      }));
    }
  }, [profile?.id]);
  const handleRemoveSingleFile = (index) => {
    
    const updatedFiles = existingDocFiles.filter((_, i) => i !== index);
    //setExistingDocFiles(updatedFiles);
    setFilesList(updatedFiles);

    setFormData(prev => ({
      ...prev,
      files: updatedFiles,
      fileName: updatedFiles.length > 0 ? updatedFiles.join("|") : "",
      filePath: prev.filePath
    }));
    // flags
    if (updatedFiles.length === 0) {
      setFileSelected(false);
      setNewFileSelected(false);
    }

    // clear input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

  };
  const handleClear = () => {
    // clear only newly selected files
    setSelectedFiles([]);

    // 🔑 restore backend files in UI
    setFilesList([...originalFiles]);

    // 🔑 keep backend payload intact
    setFormData(prev => ({
      ...prev,
      fileName: originalFiles.join("|"),
      filePath: prev.filePath
    }));

    setFileSelected(false);
    setNewFileSelected(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };


  // -------------------------------
  // SUBMIT
  // -------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const sponsorId = localStorage.getItem("userId");
    const isFileRemoved =
      originalFiles.length > 0 && filesList.length === 0;
    const updateData = {
      id: sponsorId,
      sponsorId: formData.sponsorId,
      organizationName: formData.sponsorName,
      organizationType: formData.sponsorType,
      website: formData.website,
      email: formData.email,
      phone: formData.phone,
      contactPerson: formData.contactPerson,
      address: formData.address,
      budget: formData.budget,
      studentCriteria: formData.studentCriteria,
      studyLevels: formData.studyLevels,
      fileName: isFileRemoved ? "" : filesList.join("|"),
      filePath: formData.filePath   // ✅ ALWAYS PASS


    };

    try {
      const res = await updateSponsor(updateData, dispatch);
      const userId = res?.id || profile.sponsorId;

      // 2️⃣ Upload documents if any
      if (selectedFiles?.length > 0) {
        await uploadFiles(userId);
      }

      // 3️⃣ Show success AFTER upload completes
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Profile updated successfully!",
        confirmButtonText: "OK",
      });
      await dispatch(fetchSponsorById(formData.sponsorId));
      onSave(formData);
    } catch (err) {
      Swal.fire({ text: "Failed to update profile!", icon: "error" });
    }
  };

  return (
    <div className="signup-card">
      <h2 className="walletheader">Sponsor Profile</h2>

      <h3 className="section-title">Organization Info</h3>

      <div className="row">
        <div className="form-group">
          <label>Sponsor / Organization Name *</label>
          <input
            type="text"
            value={formData.sponsorName || ""}
            onChange={(e) => handleLetterInput("sponsorName", e.target.value)}
            className={errors.sponsorName ? "input-error" : ""}
          />
          {errors.sponsorName && <p className="error-text">{errors.sponsorName}</p>}
        </div>

        <div className="form-group">
          <label>Type *</label>
          <select
            value={formData.sponsorType || ""}
            onChange={(e) =>
              setFormData({ ...formData, sponsorType: e.target.value })
            }
            className={errors.sponsorType ? "input-error" : ""}
          >
            <option value="">Select</option>
            <option value="Nonprofit">Nonprofit</option>
            <option value="Company">Company</option>
            <option value="Government">Government</option>
            <option value="Individual">Individual</option>
          </select>
          {errors.sponsorType && <p className="error-text">{errors.sponsorType}</p>}
        </div>
      </div>

      <div className="row">
        <div className="form-group">
          <label>Website</label>
          <input
            type="text"
            value={formData.website || ""}
            onChange={(e) => handleWebsiteInput(e.target.value)}
            className={errors.website ? "input-error" : ""}
          />
          {errors.website && <p className="error-text">{errors.website}</p>}
        </div>

        <div className="form-group">
          <label>Contact Person</label>
          <input
            type="text"
            value={formData.contactPerson || ""}
            onChange={(e) => handleLetterInput("contactPerson", e.target.value)}
            className={errors.contactPerson ? "input-error" : ""}
          />
          {errors.contactPerson && (
            <p className="error-text">{errors.contactPerson}</p>
          )}
        </div>
      </div>

      <h3 className="section-title">Contact Info</h3>

      <div className="row">
        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            value={formData.email || ""}
            onChange={(e) => handleEmailInput(e.target.value)}
            className={errors.email ? "input-error" : ""}
          />
          {errors.email && <p className="error-text">{errors.email}</p>}
        </div>

        <div className="form-group">
          <label>Phone *</label>
          <input
            type="text"
            maxLength={10}
            value={formData.phone || ""}
            onChange={(e) => handleNumberInput("phone", e.target.value)}
            className={errors.phone ? "input-error" : ""}
          />
          {errors.phone && <p className="error-text">{errors.phone}</p>}
        </div>
      </div>

      <div className="form-group">
        <label>Address *</label>
        <textarea
          rows="2"
          value={formData.address || ""}
          onChange={(e) => handleAddressInput(e.target.value)}
          className={errors.address ? "input-error" : ""}
        />
        {errors.address && <p className="error-text">{errors.address}</p>}
      </div>

      {/* <h3 className="section-title">Scholarship Preferences</h3>

      <div className="row">
        <div className="form-group">
          <label>Budget *</label>
          <input
            type="text"
            value={formData.budget || ""}
            onChange={(e) => handleNumberInput("budget", e.target.value)}
            className={errors.budget ? "input-error" : ""}
          />
          {errors.budget && <p className="error-text">{errors.budget}</p>}
        </div>

        <div className="form-group">
          <label>Student Criteria</label>
          <input
            type="text"
            value={formData.studentCriteria || ""}
            onChange={(e) =>
              setFormData({ ...formData, studentCriteria: e.target.value })
            }
          />
        </div>
      </div>

      <div className="form-group">
        <label>Supported Study Levels *</label>
        <select
          value={formData.studyLevels || ""}
          onChange={(e) =>
            setFormData({ ...formData, studyLevels: e.target.value })
          }
          className={errors.studyLevels ? "input-error" : ""}
        >
          <option value="">Select</option>
          <option value="High School">High School</option>
          <option value="Undergraduate">Undergraduate</option>
          <option value="Graduate">Graduate</option>
          <option value="PhD">PhD</option>
        </select>
        {errors.studyLevels && <p className="error-text">{errors.studyLevels}</p>}
      </div>*/}
      <div className="form-group col-12">
        <label>Upload Profile Photo </label>
        <input
          type="file"
          accept="image/*"
          name="documents"
          onChange={handleFileChange}
          //multiple
          ref={fileInputRef}
        // disabled={isViewMode}
        />

        {fileSelected && filesList.length > 0 && (
          <button
            type="button"
            className="btn btn-sm btn-danger mt-2"
            onClick={handleClear}
            style={{ marginTop: "10px" }}
          >
            Clear
          </button>
        )}

        {/* Display all files: backend + newly selected */}
        {filesList.length > 0 && (
          <div className="d-flex flex-column mt-2 rounded" style={{ marginTop: "5px" }}>

            {/* Backend + selected files */}
            {filesList.map((fileName, index) => (
              <div
                key={`file-${index}`}
                className="d-flex align-items-center border rounded p-2 mb-2"
                style={{
                  gap: "12px",
                  paddingLeft: "14px",
                  paddingRight: "12px",
                  color: "black"
                }}
              >
                <span style={{ flex: 1 }}>{fileName || "No File Name"}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemoveSingleFile(index)}
                  style={{ marginLeft: "5px" }}
                >
                  ×
                </button>
              </div>
            ))}

            {/* Download button (backend only) */}
            {selectedFiles.length === 0 && profile?.files?.length > 0 && (
              <button
                type="button"
                className="btn btn-sm btn-primary mt-2"
                onClick={() => downloadFileFun(formData.sponsorId, "Sponsor")}
                style={{ marginTop: "5px", marginLeft: "15px" }}
              >
                Download
              </button>
            )}
          </div>
        )}




      </div>



      <div className="btn-row">
        <button className="sign-action-btn1" onClick={handleSubmit}>
          Update Profile
        </button>

        <button
          className="sign-action-btn1 danger"
          onClick={() => {
            onCancel();
            navigate(RP.ViewSponsorProfile);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
